/* eslint-disable no-param-reassign */

import security from '@/security'
import getDataFromStorage from '@/helpers/getDataFromStorage'
import axios from '@/libs/axios'

function handler(endpoint, body) {
    const data = getHeaders(endpoint)
    data.body = body
    var data_enc = {}
    data_enc.data = security.encrypt(data)
    const request = axios.post("/", data_enc)
    return request

}

function getHeaders(data) {
    const token = getDataFromStorage().tokenCurrent
    const headers = {}

    if (token) {
        headers.Authorization = `Bearer ${token}`
    }

    const {
        VUE_APP_X_UIC_VERSION,
        VUE_APP_X_API_VERSION,
        VUE_APP_X_UIC_PLATFORM,
        VUE_APP_X_UIC_DEVICE,
        // VUE_APP_X_UIC_CLIENTKEY,
    } = process.env

    headers['X-UIC-VERSION'] = VUE_APP_X_UIC_VERSION
    headers['X-API-VERSION'] = VUE_APP_X_API_VERSION
    headers['X-UIC-PLATFORM'] = VUE_APP_X_UIC_PLATFORM
    headers['X-UIC-DEVICE'] = VUE_APP_X_UIC_DEVICE
    data.headers = headers

    return data
}



export default handler
